import React from "react";
import styles from '../styles/eventDetails.module.scss'
import EventRules from "./eventRules";
import EventList from "./eventList";
import InvitAward from "./invitAward";
import { useTranslation } from "react-i18next";
import Icon from "@/wmCompoments/Icon";

interface eventDetailsProps {
  rulesList: Record<string, any>
  currentIndex: number
  prizeConfigData?: any
}

const EventDetails: React.FC<eventDetailsProps> = (props) => {
  const { rulesList, currentIndex, prizeConfigData } = props
  
  const { t } = useTranslation('inviteFriends')
  
  return(
    <div className={styles.eventDetails}>
      <div className={styles.title}>
        <Icon name="icon-invite-content" className={styles.icon} />
        <div>{t('eventContent')}</div>
      </div>

      {/* 活动内容 */}
      <div className={styles.content}>
        <EventRules rules={rulesList?.desc} />
      </div>

      {/* 0就渲染邀请都奖励列表 */}
      {/* 1就渲染存款大福利领取奖励 */}
      {currentIndex === 0 && <EventList prizeConfigData={prizeConfigData} />}
      {currentIndex === 1 && <InvitAward />}

      {/* 活动规则 */}
      <div className={styles.content}>
        <EventRules rules={rulesList?.ruleDesc} />
      </div>

    </div>
  )
}

export default EventDetails